
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaEdit, FaTrash, FaExternalLinkAlt } from "react-icons/fa";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
import { toast } from "react-toastify";

const ListCaseStudy = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [response, loading, error, callAPI] = useApiCallHooks();

  // Fetch case studies
  useEffect(() => {
    callAPI("get", "admin/case-studies");
  }, []);

  useEffect(() => {
    if (response?.data) {
      setData(response.data);
    }
  }, [response]);

  const deleteRecord = (id) => {
    if (window.confirm("Are you sure you want to delete this case study?")) {
      callAPI("delete", `admin/case-studies/${id}`);
      toast.success("Case Study deleted successfully!");
      setData((prev) => prev.filter((item) => item.id !== id));
    }
  };

  // Search filter
  const filteredData = data?.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          {/* Heading */}
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Case Study List"
                subTitle="Manage all registered Case Studies."
              />
            </div>
            <div className="col-md-6 text-end">
              <Link to={uiRoutes.admin.casestudy.add}>
                <button className="btn btn-primary">Add Case Study</button>
              </Link>
            </div>
          </div>

          {/* Table */}
          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            {/* Search */}
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <h5 className="mb-0 fw-semibold">Case Study List</h5>
                </div>
                <div className="col-12 col-md-5"></div>
                <div className="col-12 col-md-4 d-flex justify-content-md-end justify-content-start">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by name or description"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Data Table */}
            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">Sr No.</th>
                    <th className="px-4 py-2">Name</th>
                    <th className="px-4 py-2">Image</th>
                    <th className="px-4 py-2">Live URL</th>
                    <th className="px-4 py-2">Description</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData?.map((item, index) => (
                    <tr key={item.id} className="sys-list-table__row border-bottom">
                      <th className="px-4 py-2">{index + 1}</th>

                      {/* Name */}
                      <td className="px-4 py-2 fw-medium">{item.name}</td>

                      {/* Image */}
                      <td className="px-4 py-2">
                        {item.image ? (
                          <img
                            src={item.image}
                            alt={item.name}
                            className="rounded"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <span className="text-muted">No Image</span>
                        )}
                      </td>

                      {/* Live URL */}
                      <td className="px-4 py-2">
                        {item.live_url ? (
                          <a
                            href={item.live_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Visit <FaExternalLinkAlt className="ms-1" />
                          </a>
                        ) : (
                          <span className="text-muted">N/A</span>
                        )}
                      </td>

                      {/* Description */}
                      <td className="px-4 py-2">{item.description}</td>

                      {/* Actions */}
                      <td className="px-4 py-2 text-center">
                        <div className="d-flex justify-content-center gap-2">
                         <Link
  to={uiRoutes.admin.casestudy.edit.replace(":id", item.id)}
>
                            <button
                              className="sys-list-table__action edit"
                              title="Edit Case Study"
                            >
                              <FaEdit />
                            </button>
                          </Link>
                          <button
                            className="sys-list-table__action delete"
                            title="Delete Case Study"
                            onClick={() => deleteRecord(item.id)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {filteredData?.length === 0 && (
                    <tr>
                      <td colSpan="6" className="text-center py-3">
                        No Case Studies found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ListCaseStudy;
